import { getGameConfig } from '../gameConfig';

export function raidSupportsFactions(slug: string) {
  const raid = getGameConfig().RaidsBySlug[slug];
  return !!raid?.supportsFactions;
}

export function raidSupportsWorldFirstTracker(slug: string) {
  const raid = getGameConfig().RaidsBySlug[slug];
  return !!raid?.supportsWorldFirstTracker;
}

export function raidSupportsGlobalCoverage(slug: string) {
  const raid = getGameConfig().RaidsBySlug[slug];
  return !!raid?.supportsGlobalCoverage;
}
